module.exports = __webpack_public_path__ + "a7bac0158cc6445495051ed20a66fe83.png";